import { useTranslation } from 'react-i18next'

export function DashboardPage() {
  const { t } = useTranslation()

  return (
    <section className="page">
      <header className="page__header">
        <h1>{t('dashboard.title')}</h1>
        <p className="page__subtitle">{t('dashboard.subtitle')}</p>
      </header>

      <p className="placeholder">{t('dashboard.placeholder')}</p>
    </section>
  )
}
